import React, { useState } from 'react';
import './ProjectCard.css';

const ProjectCard = ({ project, active }) => {
  // State to control video play on hover
  const [playVideo, setPlayVideo] = useState(false);

  const renderProjectMedia = () => {
    // Determine the full video URL with query parameters
    const videoUrlWithParams = project.videoUrl && project.videoUrl.includes("?") 
      ? `${project.videoUrl}&hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`
      : `${project.videoUrl}?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`;

    return (
      <div className="project-media" onMouseEnter={() => setPlayVideo(true)} onMouseLeave={() => setPlayVideo(false)}>
        {/* Always render the image */}
        <img src={project.imageUrl} alt={project.title} className="project-image" />
        {/* Conditionally render the iframe if there is a video URL */}
        {project.videoUrl && (
          <iframe
            src={videoUrlWithParams} // Use the video URL with the appended parameters
            title={project.title}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            className={`project-video ${playVideo ? 'show-video' : ''}`}
          />
        )}
      </div>
    );
  };

    return (
      <div className={`project-card ${active ? 'active' : ''}`}>
        {renderProjectMedia()}
        <h3 className="project-title">{project.title}</h3>
        <p className="project-description">{project.description}</p>
        <p className="project-technologies">{project.technologies}</p>
        <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="project-link">GitHub</a>
        {project.websiteUrl && (
          <a href={project.websiteUrl} target="_blank" rel="noopener noreferrer" className="project-link website-link">
            Visit Website
          </a>)}
      </div>
    );

};

export default ProjectCard;
